import React from "react";
// import { CheckboxOption, SelectOption } from "../imports";
import { default as CheckboxOption } from "../components/CheckboxOption";
import ToggleOption from "../components/ProductOptionToggleOption";
import { default as SelectOption } from "../components/SelectOption";
import { default as SelectOptionCart } from "../components/SelectOptionCart";
import { default as ImageOption } from "../components/ImageOption";
import styled from "styled-components";
import { device } from "../../../utils/breakPoints";
import OptionLabel from "../components/OptionLabel";
function renderOptionType({
  optionsUtility,
  option,
  isToggle = false,
}) {
  if (isToggle) {
    return (
      <ToggleOption
        optionsUtility={optionsUtility}
        option={option}
      />
    );
  }
  if (option.type === "select") {
    return optionsUtility.item === undefined
      ? <SelectOption optionsUtility={optionsUtility} option={option} />
      : <SelectOptionCart optionsUtility={optionsUtility} option={option} />;
  } else if (option.type === "image") {
    return <ImageOption optionsUtility={optionsUtility} option={option} />;
  } else {
    return <CheckboxOption optionsUtility={optionsUtility} option={option} />
  }
}

const TOGGLE_OPTION_HANDLE_ARRAY = [
  'blind-shipping',
  'next-day-shipping',
  'next-day-shipping-promo',
  'digital-proof',
]
const checkIsToggleOption = (handle)=> {
  return TOGGLE_OPTION_HANDLE_ARRAY.includes(handle)
}

export default function ProductOption({ optionsUtility, option }) {
  const isToggleOption = checkIsToggleOption(option.handle);
  return (
    <Container key={option.name} isToggle={isToggleOption}>
      {!isToggleOption && (
        <OptionLabel
          label={option.title}
          tooltipHeadLine={option.title}
          tooltipMessage={option.cod_tooltip_inner}
        />
      )}
      {renderOptionType({
        optionsUtility,
        option,
        isToggle: isToggleOption,
      })}
    </Container>
  );
}

const Container = styled.div`
  padding-bottom: ${(window.is_ab_custom_pdp) ? '10px' : '24px'};
  @media ${device.tablet} {
    padding-bottom: 8px;
  }
`;
